module.exports = __webpack_public_path__ + "img/loading.0a5290d5.gif";